/* Copyright (c) 2026 Health Endeavors, LLC. All Rights Reserved */

import { useEffect } from 'react';

import { useAppDispatch, useAppSelector } from '../../app/hooks';
import CMEQuestionnaire from './CMEQuestionnaire';
import { selectCMEState, selectCMEDocuments, setActiveStep } from './cmeSlice';
import CMETable from './CMETable';

export default function ClaimableCME() {
  const { activeStep } = useAppSelector(selectCMEState);
  const dispatch = useAppDispatch();

  useEffect(
    // cleanup function -> to reset CME to default state on component unmount
    () => () => {
      dispatch(selectCMEDocuments([]));
      dispatch(setActiveStep('selection'));
    },
    [dispatch]
  );

  return activeStep === 'selection' ? <CMETable /> : <CMEQuestionnaire />;
}
